module.exports = __webpack_public_path__ + "static/media/nu.5409d593.svg";